import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CircleNotch, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(data.message);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-white px-6">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <img src="/tfsi_mark.png" alt="TFSI logo" className="h-10 w-10" />
          <p className="font-heading text-xl font-extrabold tracking-tight text-[#032852]">TFS CRM</p>
        </div>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#569A1F]">Password recovery</p>
        <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-[#09090B]">Forgot password</h2>
        <p className="mt-2 text-sm text-[#6D6D70]">Enter your registered email address and we&apos;ll send you reset instructions.</p>

        {sent ? (
          <p className="mt-8 rounded-sm border border-[#569A1F]/30 bg-[#569A1F]/5 px-3 py-3 text-sm text-[#3f7016]" data-testid="forgot-confirmation">
            {sent}
          </p>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="forgot-form">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-xs font-bold uppercase tracking-wide text-[#52525B]">Email</Label>
              <Input id="email" type="email" required autoComplete="email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="you@tfsi-us.com"
                className="rounded-sm" data-testid="forgot-email-input" />
            </div>
            {error && (
              <p className="rounded-sm border border-[#EF4444]/30 bg-[#EF4444]/5 px-3 py-2 text-sm text-[#EF4444]" data-testid="forgot-error">{error}</p>
            )}
            <Button type="submit" disabled={loading}
              className="w-full rounded-sm bg-[#569A1F] py-5 font-semibold text-white hover:bg-[#457d18]"
              data-testid="forgot-submit-btn">
              {loading ? <CircleNotch size={18} className="animate-spin" /> : (<><EnvelopeSimple size={16} /> Send reset instructions</>)}
            </Button>
          </form>
        )}
        <p className="mt-8 text-center text-xs text-[#6D6D70]">
          <Link to="/login" className="font-bold text-[#032852] hover:underline" data-testid="back-to-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
